import { Pill } from "PFComponents/pill";
import { Tooltip } from "PFComponents/tooltip";
import { useTranslation } from "react-i18next";

export type BetaBadgeProps = {
  tooltip?: string;
  qaId?: string;
};

export const BetaBadge = ({ tooltip, qaId }: BetaBadgeProps) => {
  const { t } = useTranslation();

  const badge = <Pill small kind="warning" text={t("beta")} qaId={qaId} />;

  if (!tooltip) {
    return badge;
  }

  return (
    <Tooltip content={tooltip} triggerContainerProps={{ tabIndex: 0 }}>
      {badge}
    </Tooltip>
  );
};
